import { PaymentMethodInput } from './paymentMethod.model';

export enum InputTypes {
  Text = 'text',
  Number = 'number',
  Checkbox = 'checkbox',
  Amount = 'amount',
  AccountId = 'accountId',
  Regex = 'regex',
  Integer = 'integer',
  Select = 'select',
  Email = 'email',
  DateTime = 'date_mm_yyyy',
  Cvv = 'cvv',
  CardCvc = 'card_cvc',
  Phone = 'phone',
  DynamicSelect = 'dynamic_select',
  CreditCardNumber = 'creditcard_number',
  CreditCardVisa = 'creditcard_visa',
  CardNumber = 'card_number',
  CreditCardMastercard = 'creditcard_mastercard',
  IdentificationNumber = 'identification_number',
  PayzenPayTmAccountNumber = 'payzen_paytm_account_number',
  PayzenImpsAccountNumber = 'payzen_imps_account_number',
  Hidden = 'hidden',
  /* specific types for Display container */
  Input = 'input',
  Url = 'url',
  Button = 'button',
  QrCode = 'qr_code',
  CopyableText = 'copyable_text',
  ExpirationDate = 'expirationDate',
  FileLink = 'file_link',
  FiatAmount = 'fiatAmount',
}

export enum InputPreprocessors {
  PIQ_ENCRYPTOR = 'piq_encryptor',
  FINTEQ_HUB_CARD_WITHDRAWAL = 'finteq_hub_card_withdrawal',
  FINTEQ_HUB_CARD_DEPOSIT = 'finteq_hub_card_deposit',
  ORCHID_ENCRYPTOR = 'orchid_encryptor',
  PLIROMY_TOKENIZER = 'pliromy_tokenizer',
}

export enum InputModes {
  Numeric = 'numeric',
  Decimal = 'decimal',
  Text = 'text',
}

export interface SelectOptionItem {
  label: string;
  value: string;
}

export enum ComponentNames {
  AmountInput = 'amount_input',
  AmountSelect = 'amount_select',
  DynamicSelect = 'dynamic_select',
  Select = 'select',
  DatePicker = 'date_picker',
  Cvv = 'cvv',
  Input = 'input',
  TextField = 'text_field',
  Number = 'number',
}

export enum FormTypes {
  Account = 'account',
  Common = 'common',
}

export interface FormPayloadItem {
  name: string;
  value: string | boolean | number | null;
  isValid: boolean;
}

export interface FormPayload {
  [name: string]: FormPayloadItem;
}

export interface PaymentMethodNamedInput extends PaymentMethodInput {
  componentName: string;
}
